<div class="modal-header">
  <h4 class="modal-title pull-left">{{ title }}</h4>
</div>
<div class="modal-body">
  @if (loading$ | async) {
    <div class="loading-div">
      <mat-progress-spinner color="primary" mode="indeterminate" />
    </div>
  }
  <ngx-extended-pdf-viewer
    [src]="pdfSrc"
    [authorization]="bearerToken"
    [handTool]="false"
    [showHandToolButton]="true"
    [showRotateButton]="false"
    [showOpenFileButton]="false"
    [showTextEditor]="false"
    [showDrawEditor]="false"
    [showSecondaryToolbarButton]="false"
    [showHighlightEditor]="false"
    [showStampEditor]="false"
    [useInlineScripts]="false"
    [language]="localeId"
    height="80vh"
    (pdfLoaded)="pdfLoaded()"
    (pdfLoadingFailed)="pdfLoadingFailed($event)" />
</div>
<div class="modal-footer">
  <ng-container>
    <button type="button" class="btn btn-secondary" (click)="onClose()">{{ 'Global.Close' | translate }}</button>
  </ng-container>
</div>
